module.exports = __webpack_public_path__ + "static/media/webpack.43276027.jpg";